import { ALTERNATIVE_CTA_COPY_NJ, handleExperiment } from '@/lib/ab-testing-service'

const NJ_BEST_PLAN_SLUG = '/529-plans/new-jersey/njbest-529-college-savings-plan'
const NJ_STATE_SLUG = '/529-plans/new-jersey'

/**
 * Get the variant for the South Carolina experiment
 * @param {object} cookie - The cookie instance to store the experiment variant
 * @param {object} store - The Vue store instance
 * @returns {Promise<string>} - A promise that resolves with the variant or 'A' if there's an error
 */
export async function getNewJerseyExperimentVariant(cookie, store) {
  try {
    const currentPath = window.location.pathname
    if (currentPath === NJ_STATE_SLUG || currentPath === NJ_BEST_PLAN_SLUG) {
        const variant = await handleExperiment({
                experimentName: ALTERNATIVE_CTA_COPY_NJ,
                cookie,
                store
            })
        
        return variant
    }else{
        return null
    }

  } catch (error) {
    console.error(`Error running AB Experiment: ${ALTERNATIVE_CTA_COPY_NJ}`, error)
    return 'A'
  }
}